import { eocUserResource } from './user-resource';

export { eocUserResource } from './user-resource';

export const eocCommonResources = () => [eocUserResource];
